import { render } from "./AppMobileView.vue?vue&type=template&id=d2dfa84a&scoped=true"
import script from "./AppMobileView.vue?vue&type=script&lang=js"
export * from "./AppMobileView.vue?vue&type=script&lang=js"

import "./AppMobileView.vue?vue&type=style&index=0&id=d2dfa84a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2dfa84a"]])

export default __exports__